// extracted by mini-css-extract-plugin
export default {"container":"superAdmin_container__LTxCD","withLeftNav":"superAdmin_withLeftNav__4dLKA"};